import {
  AGENCY_OVERVIEW_DEFAULT_DAYS,
  AGENCY_OVERVIEW_PERIOD_DAYS,
  type AgencyOverviewPeriodDays,
} from '@repo/shared/marketing';

/** The Overview filters that survive a reload and a shared link. A default stays out of the URL, to keep it clean. */
export interface AgencyOverviewSearch {
  days?: AgencyOverviewPeriodDays;
  assignedTo?: string;
}

const MAX_MEMBER_ID_LENGTH = 64;

/** The router reads `?days=7` as a number; a hand-typed or old value falls back to the default instead of a 400. */
function parseDays(value: unknown): AgencyOverviewPeriodDays | undefined {
  const days = AGENCY_OVERVIEW_PERIOD_DAYS.find((period) => period === Number(value));
  return days === AGENCY_OVERVIEW_DEFAULT_DAYS ? undefined : days;
}

/** Route `validateSearch`: keeps known filters, drops anything else. */
export function parseAgencyOverviewSearch(search: Record<string, unknown>): AgencyOverviewSearch {
  const days = parseDays(search.days);
  const { assignedTo } = search;
  const keepAssignee = typeof assignedTo === 'string' && assignedTo.length > 0 && assignedTo.length <= MAX_MEMBER_ID_LENGTH;
  return { ...(days ? { days } : {}), ...(keepAssignee ? { assignedTo } : {}) };
}
